/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/multi-step-coding-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const MultiStepCodingExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    stepLayout: {
      type: 'string',
      enum: ['bullets', 'tabs'],
      title: 'Step layout',
      description: 'The layout of the steps in the exercise.'
    },
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'pre_exercise_code', 'stepLayout', 'title', 'xp'],
  definitions: {}
};
export const isValidMultiStepCodingExerciseV0 = createValidator(MultiStepCodingExerciseV0Schema);
export const MultiStepCodingExerciseV0Definition = {
  schema: MultiStepCodingExerciseV0Schema,
  validate: isValidMultiStepCodingExerciseV0
};